import React, { Component } from 'react'
import classnames from 'classnames'
import { Col, Row } from 'react-flexbox-grid'
import Card from '@material-ui/core/Card'
import Divider from '@material-ui/core/Divider'
import { withStyles } from '@material-ui/core/styles'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import IconStyles from '../../styles/icons'
import ButtonStyles from '../../styles/buttons'
import NotificationStyles from '../../styles/components/react-notification-system'
import TitledLabel from '../../controls/TitledLabel'
import TitledLine from '../../controls/TitledLine'
import RBButton from '../../controls/RBButton'
import Icon from '@material-ui/core/Icon'
import { fetchEOBFile } from '../../redux/actions/eobActions'
import NotificationSystem from 'react-notification-system'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { localize } from '../../util/Localizer'
import { ClaimStatus } from '../../redux/SubmitClaim/Common'
import GenericModal from '../../widgets/common/GenericModal'

class ClaimSummary extends Component {
  constructor (props) {
    super(props)
    this.viewClaimLine = this.viewClaimLine.bind(this)
    this.fileDownloadError = this.fileDownloadError.bind(this)
    this.downloadEoB = this.downloadEoB.bind(this)
    this.downloadEOBFile = this.downloadEOBFile.bind(this)
    this.notificationSystem = React.createRef()
    this.returnClaimLine = this.returnClaimLine.bind(this)
    this.state = { showGenericModal: false }
  }

  viewClaimLine (claimId, claimType) {
    this.props.push(`/Claims/${claimId}/${claimType}/ClaimLines`)
  }

  downloadEoB (fileName) {
    this.props.fetchEOBFile(fileName, this.downloadEOBFile, this.fileDownloadError)
  }

  fileDownloadError () {
    const notification = this.notificationSystem.current
    const { error = {} } = this.props
    const { rawResponse, message } = error
    if (notification === undefined) { return }

    // clear all notifications
    notification.clearNotifications()

    // show the notification if available
    if (error) {
      // set the default notification system
      const serverError = rawResponse && rawResponse.error_description
      notification.addNotification({
        title: `${serverError || message}`,
        level: 'error',
        position: 'tc',
        autoDismiss: 0
      })
    }
  }

  downloadEOBFile () {
    /*eslint-disable */
    if (typeof (this.props.eobFile) === 'object' && !this.props.eobFile.hasErrorField) {
      this.props.eobFile.map((file, index) => {
        const pdfFielBlob = this.b64toBlob(file.fileContentField, 'application/pdf')
        const fileName = file.fileNameField
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE workaround
          window.navigator.msSaveOrOpenBlob(pdfFielBlob, fileName)
        } else {
          var downloadLink = document.createElement('a')
          downloadLink.download = fileName
          downloadLink.innerHTML = 'Download File'
          var URL = window.URL || window.webkitURL
          downloadLink.href = URL.createObjectURL(pdfFielBlob)
          if (!('webkitURL' in window)) {
            // Firefox requires the link to be added to the DOM before it can be clicked.
            downloadLink.href = URL.createObjectURL(pdfFielBlob)
            downloadLink.onclick = this.destroyDowloadLink
            downloadLink.style.display = 'none'
            document.body.appendChild(downloadLink)
          }

          downloadLink.click()
          URL.revokeObjectURL(downloadLink)
        }
      })
    } else {
      this.setState({ showGenericModal: true })
    }
  }
  /* eslint-enable */
  b64toBlob (b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = window.atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)

      byteArrays.push(byteArray)
    }

    const blob = new window.Blob(byteArrays, { type: contentType })
    return blob
  }

  destroyDowloadLink (event) {
    document.body.removeChild(event.target)
  }

  returnClaimLine (claim, serviceDate, serviceDateFormat) {
    const { classes = {} } = this.props
    const self = this
    return (
      <Card key={claim.claimId} className={ classnames(classes.summaryCard, classes.baseCard) }>
        <Row between='md' className='summaryHeader'>
          <Col lg={8} md={8} xs={12}>
            <Row between='xs'>
              <Col className={'claim_responsive_padding'}>
                <TitledLine title='pages.claims.claimNumber' value={claim.claimCode} className='claimId claimsTitleLine' />
              </Col>
              <Col className={'claim_responsive_padding'}>
                <TitledLine title='pages.claims.status' value={claim.claimStatus} className={`${claim.claimStatus} claimsTitleLine`} />
              </Col>
              <Col className={'claim_responsive_padding'}>
                <TitledLine title='pages.claims.name' value={claim.patientName} className='claimId claimsTitleLine' />
              </Col>
            </Row>
          </Col>
          <Col lg={4} md={12} xs={12}>
            <Row end='lg' className={'claimButtons'}>
              <Col>
                {claim.explanationOfBenefitsFileExists === true
                  ? <RBButton
                    label={localize('pages.claims.eob')}
                    variant='outlined'
                    className={classes.fixedHeightButton}
                    onClick={() => { self.downloadEoB(claim.eoBFileName) }}
                    icon={<Icon className={classes.borderedIcon}>arrow_downward</Icon>} />
                  : null}
                <RBButton
                  label={localize('pages.claims.claimDetails')}
                  variant='outlined'
                  className={classes.fixedHeightButton}
                  onClick={() => { self.viewClaimLine(claim.claimId, claim.claimType) }} />
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider />
        <Row className='forPrint'>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.ProcDate' value={claim.claimStatusDate} format={claim.claimStatusDate === 'N/A' ? 'text' : 'date'} />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.dateOfService' value={serviceDate} format={serviceDateFormat} />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.amountSubmitted' value={claim.submittedAmmount} format='currency' />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.amountPaid' value={claim.paidAmount} format='currency' showRaw={ClaimStatus.isPending(claim.paidAmount)} />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.claimEstimate' value={claim.claimType} />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.benefit' value={claim.benefitName} />
          </Col>
        </Row>
      </Card>
    )
  }

  returnClaimImageLine (claim, serviceDate, serviceDateFormat) {
    const { classes = {} } = this.props
    const self = this
    return (
      <Card key={claim.claimId} className={ classnames(classes.summaryCard, classes.baseCard) }>
        <Row between='md' className='summaryHeader'>
          <Col lg={8} md={8} xs={12}>
            <Row between='xs'>
              <Col className={'claim_responsive_padding'}>
                <TitledLine title='pages.claims.claimNumber' value={claim.claimCode} className='claimId claimsTitleLine' />
              </Col>
              <Col className={'claim_responsive_padding'}>
                <TitledLine title='pages.claims.status' value={claim.claimStatus} className={`${claim.claimStatus} claimsTitleLine`} />
              </Col>
              <Col className={'claim_responsive_padding'}>
                <TitledLine title='pages.claims.name' value={claim.patientName} className='claimId claimsTitleLine' />
              </Col>
            </Row>
          </Col>
          <Col lg={4} md={12} xs={12}>
            <Row end='lg' className={'claimButtons'}>
              <Col>
                <RBButton
                  label={localize('pages.claims.viewFiles')}
                  variant='outlined'
                  className={classes.fixedHeightButton}
                  onClick={() => { self.viewClaimLine(claim.claimId, claim.claimType) }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider />
        <Row className='forPrint'>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.submittedDate' value={claim.submittedDate} format={'date'} />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.claimEstimate' value={claim.claimType} />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.benefit' value={claim.benefitName} />
          </Col>
        </Row>
      </Card>
    )
  }

  render () {
    const self = this

    return (
      <div className='claimSummary' id='claimSummary'>
        <NotificationSystem ref={this.notificationSystem} style={NotificationStyles} />
        <Col>
          {this.props.claims.map(function (claim, indx) {
            let serviceDate
            let serviceDateFormat
            if (claim.serviceDate) {
              if (claim.serviceDate.length > 1) {
                serviceDate = localize('pages.claims.multiple')
                serviceDateFormat = 'Text'
              } else {
                serviceDate = claim.serviceDate[0]
                serviceDateFormat = 'date'
              }
            }
            return (claim.hasLines === true || claim.receipts.length === 0)
              ? self.returnClaimLine(claim, serviceDate, serviceDateFormat)
              : self.returnClaimImageLine(claim, serviceDate, serviceDateFormat)
          })
          }
          {this.state.showGenericModal
            ? <GenericModal
              open={this.state.showGenericModal}
              handleClose={() => {
                this.setState({ showGenericModal: false })
              }}
              modal
              message='Something went wrong while downloading resource. Please try again'
            /> : null}
        </Col>
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    error: state.EOBReducer.error,
    eobFile: state.EOBReducer.eobFile || ''
  }
}

const ConnectedClaimSummary = connect(mapStateToProps, { fetchEOBFile })(injectIntl(ClaimSummary))

const styles = {
  ...CardStyles,
  ...IconStyles,
  ...ButtonStyles,
  claimButtons: {
    ['@media print']: { // eslint-disable-line no-useless-computed-key
      display: 'none !important'
    }
  }
}

export default withStyles(styles)(ConnectedClaimSummary)



// WEBPACK FOOTER //
// ./src/widgets/Claims/ClaimSummary.js